import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LeadSourceView } from '@api-proxies';
import { LeadSourceService } from '@http/clients/lead-source.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-lead-source-editor',
    templateUrl: './lead-source-editor.component.html',
    styleUrls: ['./lead-source-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class LeadSourceEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    leadSourceItems?: LeadSourceView[];
    selectedLeadSource?: LeadSourceView;

    constructor(private readonly leadSourceService: LeadSourceService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.leadSourceItems = await this.leadSourceService.getAll();
        if (this.bindingProperty !== null) {
            const foundItem = this.leadSourceItems?.find((x) => x.id === this.bindingProperty);
            this.selectedLeadSource = foundItem;
        }
    }

    onLeadSourceChange() {
        this.bindingProperty = this.selectedLeadSource?.id ?? null;
        this.valueChange.emit();
    }
}
